
        <div class="card-head">
            <button class="btn btn-info btn-sm pull-right" (click)="openModal(actionRipeur)">
                <i class="fa fa-plus" aria-hidden="true"></i> Nouveau
            </button>
        </div>

        <div class="card-body">
            <div class="row">
                <!-- <table class="table"> -->
                    <table datatable class="row-border hover" [dtOptions]="dtOptions" [dtTrigger]="dtTigger">
                    <thead>
                        <tr>
                            <th *ngIf="entrepriseType == '1'">Entreprise</th>
                            <th>Identification</th>
                            <th>Nom</th>
                            <th>Prénom</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of listRipeur" class="pointer-cl">
                            <td (click)="emitDataRipeurs(item)" *ngIf="entrepriseType == '1'">{{item.entrepriseId != null ? item.entreprise.name:''}}</td>
                            <td (click)="emitDataRipeurs(item)">{{item.immatricule}}</td>
                            <td (click)="emitDataRipeurs(item)">{{item.firstname}}</td>
                            <td (click)="emitDataRipeurs(item)">{{item.lastname}}</td>
                            <td>
                                <button class="btn btn-sm btn-danger" (click)="beforeDelete(item.id)">
                                    <i class="fas fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

<ng-template #actionRipeur>
    <div class="modal-header">

        <h4 class="modal-title" *ngIf="checkAction === 'add'">Nouveau Ripeur</h4>
        <h4 class="modal-title" *ngIf="checkAction === 'update'">Modification Ripeur</h4>

        <button type="button" class="close" aria-label="Close" (click)="resetField()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <label>Identification</label>
            <input type="text" class="form-control" name="ripeurImmatricule" [(ngModel)]="ripeurImmatricule">
        </div>
        <div class="form-group">
            <label>Nom</label>
            <input type="text" class="form-control" name="ripeurFirstname" [(ngModel)]="ripeurFirstname">
        </div>
        <div class="form-group">
            <label>Prénom</label>
            <input type="text" class="form-control"  name="ripeurLastname" [(ngModel)]="ripeurLastname">
        </div>
        <div class="form-group" *ngIf="entrepriseType == '1'">
            <label>Entreprise</label>
            <select name="idEntreprise" [(ngModel)]="idEntreprise" [ngModelOptions]="{standalone: true}" class="form-control">
                <option *ngFor="let entreprise of listEntreprise" value="{{entreprise.id}}">{{entreprise.name}}</option>
            </select>
        </div>
    </div>
    <div class="modal-footer">
        <button *ngIf="checkAction === 'add'" type="button" class="btn btn-info" (click)="addRipeurs()"><i class="fa fa-plus-circle" aria-hidden="true"></i> Ajouter</button>
        <button *ngIf="checkAction === 'update'" type="button" class="btn btn-info" (click)="updateRipeurs()"><i class="fa fa-check-circle" aria-hidden="true"></i> Enregister</button>
    </div>
</ng-template>

<ng-template #confirmDelete>
    <div class="card-body">
        Etes-vous sûr de vouloir supprimer?
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="deleteRipeurs()">OUI</button>  
        <button type="button" class="btn btn-outline-dark" (click)="resetField()">NON</button>         
    </div>
</ng-template>
